//helper functions
import { Link, useLoaderData } from "react-router-dom";
import {createBudget,createExpense,deleteItem,fetchData, waait } from "../helpers";
import Intro from "../components/Intro"
import { toast } from "react-toastify";
import AddBudgetForm from "../components/AddBudgetForm";
import AddExpenseForm from "../components/AddExpenseForm";
import BudgetItem from "../components/BudgetItem";
import Table from "../components/Table";

export const dashboardloader=()=>{
    const userName = fetchData("userName")
    const budgets = fetchData("budgets")
    const expenses = fetchData("expenses")
    return { userName, budgets,expenses}
}
//action
export async function dashboardAction({request}){
    await waait()
    const data = await request.formData()
    const {_action,...values} = Object.fromEntries(data)
    console.log(_action)
    if(_action === "newUser"){
    try{
        localStorage.setItem("userName",JSON.stringify(values.userName))
        return toast.success(`Welcome, ${values.userName}`)
    }
    catch(e){
        throw new Error("there was a problem creating your account")
    }
    }
    if(_action === "createBudget"){
        try{
            //create budget
            createBudget({
                name:values.newBudget,
                amount:values.newBudgetAmount
            })
            return toast.success("budget Created")
        }
        catch(e){
            throw new Error("there was a problem creating")
        }
    }
    if(_action === "createExpense"){
        try{
            //create an Expense
            createExpense({
                name:values.newExpense,
                amount:values.newExpenseAmount,
                budgetId: values.newExpenseBudget
            })
            return toast.success(`Expense ${values.newExpense}`)
        }
        catch(e){
            throw new Error("there was a problem creating your expense")
        }
    }

    if(_action === "deleteExpense"){
        try{
            //create an Expense
            deleteItem({
                key:"expenses",
                id:values.expenseId
            })
            return toast.success(`Expense Deleted`)
        }
        catch(e){
            throw new Error("there was a problem Deleting your expense")
        }
    }
}
const Dashboard = () => {
    const {userName, budgets, expenses} = useLoaderData() //runs every time we runs a component
    return (
        <>
        {userName ?         /* it's conditional on weather username exist or not */
        <div className="dashboard">
            <h1>Welcome back, <span className="accent">{userName}</span></h1>
            <div className="grid-sm">
                {
                    budgets && budgets.length > 0 ?
                    (
                    <div className="grid-lg">
                        <div className="flex-lg">
                            <AddBudgetForm />
                            <AddExpenseForm budgets={budgets} />
                        </div>
                        <h2>Existing Budgets</h2>
                        <div className="budgets">
                            {budgets.map((budget)=>(
                                <BudgetItem key={budget.id} budget={budget} />
                            ))}
                        </div>
                        {
                            expenses && expenses.length > 0 && (
                                <div className="grid-md">
                                    <h2>Recent expenses</h2>
                                    <Table expenses={expenses.sort((a,b)=>b.createdAt-a.createdAt).slice(0,8)}/>
                                    {expenses.length > 8 && (
                                        <Link
                                        to="expenses"
                                        className="btn btn--dark"
                                        >View all expenses
                                        </Link>
                                    )}
                                </div>
                            )
                        }
                    </div>
                    )
                : (
                <div className="grid-sm">
                    <p>Personal budgeting is the secret to financial freedom</p>
                    <p>Create a budget to get started</p>
                    <AddBudgetForm />
                </div>
                )
                }
            </div>
        </div>
        :            /* 1. if user name exists  show <p>{userName}</p> */
(<Intro/>) }        {/* 2. and if not show this  component that I've already made, hint: it's the starting page for new users */}
        </>
    );
}

export default Dashboard;